import { render } from "./TemplateFive.vue?vue&type=template&id=c664e8cc"
import script from "./TemplateFive.vue?vue&type=script&lang=js"
export * from "./TemplateFive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__